import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Reveal } from "../../Components/Reveal/Reveal";
import { Helmet } from "react-helmet-async";
import { ContactSection } from "../../Components/ContactSection/ContactSection";
import { WhyChooseDataDept } from "../../Components/WhyChooseClifster/WhyChooseClifster";
import "./style.css";
import ecom from "../../Assets/Services/ecommers.jpg";
import soft from "../../Assets/Services/soft.jpg";
import it from "../../Assets/Services/it.jpg";
import crm from "../../Assets/Services/crm.jpg";
import web from "../../Assets/Services/web.jpg";
import management from "../../Assets/Services/management.jpg";
import { Button } from "../../Components/Button/Button";
import { LiaChessSolid } from "react-icons/lia";
import { IoStorefrontOutline } from "react-icons/io5";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { BsHddNetwork } from "react-icons/bs";
import { BsJournalCode } from "react-icons/bs";
import { LiaPeopleCarrySolid } from "react-icons/lia";
export const Service = (prop) => {
  const { id } = useParams();
  const [selected, setSelected] = useState("development");
  const scrollRef = useRef(null);

  useEffect(() => {
    if (id !== "general") {
      setSelected(id);

      const timeoutId = setTimeout(() => {
        const scrollElement = scrollRef.current;
        const topOffset = scrollElement.getBoundingClientRect().top - 70;
        window.scrollBy({ top: topOffset, left: 0, behavior: "smooth" });
        // Your timeout logic here
        //scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', offset: { top: -100 } });
      }, 1); // 3000 milliseconds = 3 seconds

      return () => {
        // Clear the timeout when component unmounts or before the effect runs again
        clearTimeout(timeoutId);
      };
    }
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
    prop.setSelectedPage("service");
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Services - DataDept | Premium Services Tailored to Your Business Needs
        </title>
        <meta
          name="description"
          content="Explore our comprehensive IT services: Custom software development, CRM solutions, innovative mobile apps, and SaaS platforms. Elevate your business with our cutting-edge technology and expertise."
        />
        <link rel="canonical" href="/services" />
      </Helmet>

      {id === "general" && (
        <>
          <section className="about-page-section-1 container-style">
            <div className="content-sizing about-page-section-1-wrapper">
              <div className="header-into-about-section">
                <Reveal delay={0.1}>
                  <span className="light-tag">Our Services</span>
                </Reveal>
                <Reveal delay={0.2}>
                  <h1 className="header-tag-about">
                    Crafting Cutting-Edge Software Solutions to Propel Your
                    Business Forward
                  </h1>
                </Reveal>
                <Reveal delay={0.3}>
                  <h2 className="sub-header-tag-about">
                    At DataDept, we are dedicated to crafting tailored software
                    solutions and providing unwavering support to fulfill your
                    every requirement.
                  </h2>
                </Reveal>
              </div>
            </div>
          </section>{" "}
        </>
      )}

      {id !== "general" && (
        <>
          <section className="about-page-section-1 container-style">
            <div className="content-sizing about-page-section-1-wrapper">
              <div className="header-into-about-section">
                <span className="light-tag">Our Services</span>
                <h1 className="header-tag-about">
                  Crafting Cutting-Edge Software Solutions to Propel Your
                  Business Forward
                </h1>
                <h2 className="sub-header-tag-about">
                  At DataDept, we are dedicated to crafting tailored software
                  solutions and providing unwavering support to fulfill your
                  every requirement.
                </h2>
              </div>
            </div>
          </section>{" "}
        </>
      )}

      <section className="service-section-2 container-style" ref={scrollRef}>
        <div className="content-sizing service-section-2-wrapper">
          <Reveal delay={0.2}>
            <div className="header-service-section-2">
              <span className="small-tag">Work Model</span>
              <h2>Detailing of our products</h2>
              <ul>
                <li
                  className={
                    selected === "development" ? "active-selection-ser" : ""
                  }
                  onClick={() => setSelected("development")}
                >
                  Software Development
                </li>
                <li
                  className={
                    selected === "e-commerces" ? "active-selection-ser" : ""
                  }
                  onClick={() => setSelected("e-commerces")}
                >
                  E-Commerces
                </li>
                <li
                  className={selected === "crm" ? "active-selection-ser" : ""}
                  onClick={() => setSelected("crm")}
                >
                  CRM Solutions
                </li>
                <li
                  className={selected === "web" ? "active-selection-ser" : ""}
                  onClick={() => setSelected("web")}
                >
                  Web Application
                </li>
                <li
                  className={selected === "it" ? "active-selection-ser" : ""}
                  onClick={() => setSelected("it")}
                >
                  IT Support
                </li>
                <li
                  className={
                    selected === "management" ? "active-selection-ser" : ""
                  }
                  onClick={() => setSelected("management")}
                >
                  Management
                </li>
              </ul>
            </div>
          </Reveal>

          <div className="service-content-section">
            {selected === "development" && (
              <Reveal>
                <div className="left-image-service">
                  <img src={soft} alt="Software Developement" loading="lazy" />
                </div>

                <div className="right-service-text">
                  <AiOutlineAppstoreAdd />
                  <h2>Software Development</h2>

                  <p>
                    Bespoke Solutions for Unique Challenges: Every business has
                    unique needs and challenges. Our custom software development
                    services are designed to meet these specific requirements,
                    delivering tailor-made solutions that fit your business
                    perfectly. From ideation to launch and beyond, we ensure
                    your software is not just functional but also a step ahead
                    of the competition.
                  </p>
                </div>
              </Reveal>
            )}

            {selected === "e-commerces" && (
              <Reveal>
                <div className="left-image-service">
                  <img src={ecom} alt="E-commerces" loading="lazy" />
                </div>

                <div className="right-service-text">
                  <IoStorefrontOutline />
                  <h2>E-Commerces</h2>

                  <p>
                    Our eCommerce solutions offer a comprehensive suite of
                    services tailored to empower your online store and enhance
                    your digital sales presence. From seamless website
                    integration to robust security measures and round-the-clock
                    support, we ensure your online marketplace operates
                    efficiently and securely. Leveraging advanced technology and
                    personalized strategies, we help your business excel in the
                    competitive digital marketplace, driving growth and customer
                    satisfaction.
                  </p>
                </div>
              </Reveal>
            )}

            {selected === "crm" && (
              <Reveal>
                <div className="left-image-service">
                  <img
                    src={crm}
                    alt="Customer Relationship Management"
                    loading="lazy"
                  />
                </div>

                <div className="right-service-text">
                  <LiaPeopleCarrySolid />
                  <h2>Customer Relationship Management (CRM)</h2>

                  <p>
                    Our CRM software offers a comprehensive solution for
                    managing customer relationships, improving engagement, and
                    driving sales. With advanced analytics, automation, and a
                    user-friendly interface, it empowers teams to deliver
                    exceptional service and gain valuable insights. Designed for
                    businesses of any size, our CRM ensures efficiency,
                    satisfaction, and growth in the digital age.
                  </p>
                </div>
              </Reveal>
            )}

            {selected === "web" && (
              <Reveal>
                <div className="left-image-service">
                  <img src={web} alt="Web Application" loading="lazy" />
                </div>

                <div className="right-service-text">
                  <BsJournalCode />
                  <h2>Web Application</h2>

                  <p>
                    Crafting Digital Experiences: Your website is often the
                    first point of contact with your customers. We create
                    responsive, engaging, and user-friendly websites that not
                    only look great but also perform excellently. From
                    e-commerce platforms to informational sites, our web
                    development team brings your digital presence to life.
                  </p>
                </div>
              </Reveal>
            )}

            {selected === "it" && (
              <Reveal>
                <div className="left-image-service">
                  <img src={it} alt="IT Support" loading="lazy" />
                </div>

                <div className="right-service-text">
                  <BsHddNetwork />
                  <h2>IT Solutions</h2>

                  <p>
                    End-to-End Support for Your Technology Needs: Our IT
                    services encompass a wide range of solutions designed to
                    ensure your operations run smoothly and securely. From
                    infrastructure management to cybersecurity and support, we
                    provide the backbone your business needs to thrive in
                    today's digital world.
                  </p>
                </div>
              </Reveal>
            )}

            {selected === "management" && (
              <Reveal>
                <div className="left-image-service">
                  <img src={management} alt="Management" loading="lazy" />
                </div>

                <div className="right-service-text">
                  <LiaChessSolid />
                  <h2>Management</h2>
                  <p>
                    Our Management Service provides peace of mind by handling
                    all aspects of software maintenance and support for the
                    solutions we develop. This includes regular updates, bug
                    fixes, and proactive monitoring to ensure your software runs
                    smoothly, without disruptions. By entrusting us with the
                    management of your software, you free up your resources to
                    focus on core business activities, while we take care of any
                    technical issues. Our dedicated team ensures your software
                    is always up-to-date, secure, and performing optimally, all
                    for a straightforward management fee.
                  </p>
                </div>
              </Reveal>
            )}
          </div>
          <Reveal delay={0.3}>
            <Button onClick={() => prop.setIsOpen(true)}>
              Let's start your project!
            </Button>
          </Reveal>
        </div>
      </section>

      <WhyChooseDataDept />
    </>
  );
};
